import React from 'react';
import pt from 'prop-types';
import { FieldLocalized } from 'components/form';
import withWidget from './with-widget';
import withLocale from './with-locale';

const DEFAULT_AUTO_SIZE = true;
const DEFAULT_ROWS = 3;
const DEFAULT_MAX_ROWS = 10;

function SwellTextarea({ value, localeValue, field, localized, onChange }) {
  const { prop, label, description, defaultValue, params } = field;
  const {
    autoSize = DEFAULT_AUTO_SIZE,
    rows = DEFAULT_ROWS,
    maxRows = DEFAULT_MAX_ROWS,
    placeholder,
  } = params || {};

  return (
    <FieldLocalized
      type="textarea"
      name={prop}
      label={label}
      value={value}
      defaultValue={defaultValue}
      localeValue={localeValue}
      onChange={onChange}
      hint={description}
      localized={localized}
      placeholder={placeholder}
      autoSize={autoSize}
      rows={rows}
      maxRows={maxRows}
      tooltipAlign="end"
      hintOnLast
    />
  );
}

SwellTextarea.propTypes = {
  value: pt.string,
  localeValue: pt.object,
  field: pt.object,
  localized: pt.bool,
  onChange: pt.func,
};

export default withWidget(withLocale(SwellTextarea));
